import { useState, type FC, type FormEvent } from 'react';

const NewsletterSection: FC = () => {
  const [status, setStatus] = useState<'idle' | 'success' | 'error'>('idle');
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    const form = e.currentTarget;
    const formData = new FormData(form);

    const honeypotValue = (formData.get('website_alt') as string || '').trim();
    if (honeypotValue) {
      setStatus('success');
      setMessage('订阅成功！感谢您的关注。');
      form.reset();
      return;
    }

    try {
      const response = await fetch('https://readdy.ai/api/form/d9q2mafnahb7382ov57g', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(
          Array.from(formData.entries())
            .filter(([key]) => key !== 'website_alt')
            .map(([key, value]) => [key, value.toString()])
        ).toString(),
      });

      const responseText = await response.text();
      let parsed: Record<string, unknown> = {};
      try { parsed = JSON.parse(responseText); } catch { /* ignore parse error */ }

      if (response.ok) {
        setStatus('success');
        setMessage('订阅成功！感谢您的关注，我们将为您推送最新的ASMR内容资讯。');
        form.reset();
      } else {
        const serverMsg = (parsed?.meta as Record<string, unknown>)?.message
          || (parsed?.message as string)
          || responseText
          || '订阅失败';
        setStatus('error');
        setMessage(typeof serverMsg === 'string' ? serverMsg : '订阅失败，请稍后重试。');
      }
    } catch {
      setStatus('error');
      setMessage('网络错误，请检查您的网络连接后重试。');
    }
  };

  return (
    <section className="py-16 md:py-20 bg-secondary-900">
      <div className="max-w-2xl mx-auto px-4 md:px-6 text-center">
        <div className="w-12 h-12 mx-auto mb-5 flex items-center justify-center rounded-full bg-accent-500/20 text-accent-400">
          <i className="ri-mail-send-line text-xl"></i>
        </div>
        <h2 className="text-2xl md:text-3xl font-heading font-semibold text-background-50 mb-3">
          订阅我们的新闻简报
        </h2>
        <p className="text-sm text-foreground-200 mb-8 leading-relaxed">
          第一时间获取最新ASMR内容推荐、创作者动态和社区活动信息。
        </p>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col sm:flex-row gap-3 max-w-md mx-auto"
          data-readdy-form
        >
          <input
            type="email"
            name="email"
            required
            placeholder="请输入您的邮箱地址"
            className="flex-1 px-5 py-3 rounded-full bg-background-50/10 border border-background-50/20 text-background-50 placeholder:text-foreground-300 text-sm focus:outline-none focus:border-accent-400 transition-colors"
          />
          <input
            type="text"
            name="website_alt"
            tabIndex={-1}
            autoComplete="off"
            aria-hidden="true"
            readOnly
            className="honeypot-field"
          />
          <button
            type="submit"
            className="px-6 py-3 bg-accent-500 text-background-50 dark:text-foreground-950 rounded-full font-medium text-sm hover:bg-accent-600 transition-all duration-300 whitespace-nowrap"
          >
            立即订阅
          </button>
        </form>

        {status !== 'idle' && (
          <div className={`mt-4 text-sm ${status === 'success' ? 'text-accent-400' : 'text-red-400'}`}>
            {message}
          </div>
        )}
      </div>
    </section>
  );
};

export default NewsletterSection;